import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import {
  FiSearch,
  FiRefreshCw,
  FiDownload,
  FiEye,
  FiXCircle,
  FiAlertCircle,
  FiFileText,
} from "react-icons/fi";
import Swal from "sweetalert2";

export default function Mandates() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [mandates] = useState([
    {
      id: 1,
      mandateId: "MND-001",
      userId: "USR-001",
      userName: "Rajesh Kumar",
      bankName: "HDFC Bank",
      accountNumber: "****1234",
      amountLimit: 100000,
      status: "Active",
      createdDate: "2024-01-15",
      expiryDate: "2025-01-15",
      provider: "NPCI",
    },
    {
      id: 2,
      mandateId: "MND-002",
      userId: "USR-002",
      userName: "Priya Sharma",
      bankName: "ICICI Bank",
      accountNumber: "****5678",
      amountLimit: 50000,
      status: "Failed",
      createdDate: "2024-01-10",
      expiryDate: null,
      provider: "NPCI",
    },
    {
      id: 3,
      mandateId: "MND-003",
      userId: "USR-003",
      userName: "Amit Patel",
      bankName: "SBI",
      accountNumber: "****9012",
      amountLimit: 200000,
      status: "Expired",
      createdDate: "2023-01-20",
      expiryDate: "2024-01-20",
      provider: "NPCI",
    },
  ]);

  const handleResync = (mandateId) => {
    Swal.fire({
      title: "Resync Mandate?",
      text: "This will trigger a resync with the provider.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Resync",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Resync Started!", "Mandate resync process initiated.", "success");
      }
    });
  };

  const handleCancel = (mandateId) => {
    Swal.fire({
      title: "Cancel Mandate?",
      text: "This will cancel the mandate permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Cancel",
      confirmButtonColor: "#ef4444",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Cancelled!", "Mandate has been cancelled.", "success");
      }
    });
  };

  const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const filteredMandates = mandates.filter((mandate) => {
    const matchesSearch =
      mandate.mandateId.includes(searchTerm) ||
      mandate.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      mandate.bankName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || mandate.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMandates.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredMandates.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                 <div className="content-page-header content-page-headersplit">
                <h5>Mandates Monitor</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/mutual-funds/mandates">Mutual Funds</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Mandates Monitor
                  </li>
                </ol>
              </nav>
           
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                {/* Filters */}
                <div className="row g-2 flex-grow-1">
                  {/* Search */}
                  <div className="col-12 col-md-6">
                    <div className="position-relative">
                      <FiSearch
                        style={{
                          position: "absolute",
                          left: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#64748b",
                          zIndex: 1,
                        }}
                      />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by mandate ID, user name, or bank..."
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setCurrentPage(0);
                        }}
                        style={{ paddingLeft: "40px" }}
                      />
                    </div>
                  </div>

                  {/* Status Filter */}
                  <div className="col-12 col-md-3">
                    <select
                      className="form-control"
                      value={statusFilter}
                      onChange={(e) => {
                        setStatusFilter(e.target.value);
                        setCurrentPage(0);
                      }}
                    >
                      <option value="all">All Status</option>
                      <option value="Active">Active</option>
                      <option value="Failed">Failed</option>
                      <option value="Expired">Expired</option>
                    </select>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="ms-md-3 mt-3 mt-md-0">
                  <button className="btn btn-primary">
                    Export
                  </button>
                </div>
              </div>
            </div>

            {/* Mandates Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Mandate ID</th>
                          <th>User</th>
                          <th>Bank</th>
                          <th>Account Number</th>
                          <th>Amount Limit</th>
                          <th>Status</th>
                          <th>Provider</th>
                          <th>Expiry Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="9">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((mandate) => (
                            <tr key={mandate.id}>
                              <td style={{ fontWeight: "500" }}>{mandate.mandateId}</td>
                              <td style={{ fontWeight: "500" }}>{mandate.userName}</td>
                              <td>{mandate.bankName}</td>
                              <td>{mandate.accountNumber}</td>
                              <td style={{ fontWeight: "600" }}>{formatINR(mandate.amountLimit)}</td>
                              <td>
                                <span
                                  className="badge"
                                  style={{
                                    background:
                                      mandate.status === "Active"
                                        ? "#d1fae5"
                                        : mandate.status === "Failed"
                                        ? "#fee2e2"
                                        : "#fef3c7",
                                    color:
                                      mandate.status === "Active"
                                        ? "#10b981"
                                        : mandate.status === "Failed"
                                        ? "#ef4444"
                                        : "#f59e0b",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                  }}
                                >
                                  {mandate.status}
                                </span>
                              </td>
                              <td>{mandate.provider}</td>
                              <td>{mandate.expiryDate || "-"}</td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    title="View Details"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </div>
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleResync(mandate.mandateId)}
                                    title="Resync Mandate"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-redo"></i>
                                  </div>
                                  <div
                                    className="delete-table"
                                    onClick={() => handleCancel(mandate.mandateId)}
                                    title="Cancel Mandate"
                                    style={{ cursor: "pointer", color: "#ef4444" }}
                                  >
                                    <i className="fas fa-times-circle"></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
